import React, { useState, useEffect } from 'react';

import AccountSelectOption from "../../commons/components/AccountSelectOption";

import Http from "../../commons/utils/Http";

import { ScreenActions, BoxFields } from './styles';

function DataSearch(props) {
    const [applications, setApplications] = useState([]);

    useEffect(() => {
        getApplications();
    }, []);

    function getApplications() {
        Http.get(`/applications/get-all?offset=${0}&order=${"name"}`, Http.headers)
            .then(response => {
                const responseData = response.data;
                if (!responseData.response.error) {
                    setApplications(formatSelectApplicationsData(responseData.data));
                }
            }).catch(err => {
                setApplications([]);
            })
    }

    function formatSelectApplicationsData(data) {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}
                item.label = `${dataItem.name}`;
                item.value = dataItem.id;
                array.push(item)
            })
        }
        return array;
    }

    return (
        <ScreenActions>
            <BoxFields flex="auto">
                <AccountSelectOption
                    placeholder="Aplicações"
                    style={{ width: '100%' }}
                    data={applications}
                    showSearch={false}
                    {...props}
                />
            </BoxFields>
        </ScreenActions>
    )
}

export default DataSearch;
